export class SelectOption {
  label: string;
  value: string;
  selected?: boolean;

  constructor(label: string, value: any, selected?: boolean) {
    this.label = label;
    this.value = value.toString();
    this.selected = selected;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/dynamic-form/shared/question-select-option.ts